function addPrefetch(kind, url, as) {
    const linkEl = document.createElement('link');
    linkEl.rel = kind;
    linkEl.href = url;
    if (as) {
        linkEl.as = as;
    }
    document.head.append(linkEl);
}
;
function getPlayLabel($container) {
    return $container.attr('label') || 'Play';
}
function addPlayButton($container, btnClass) {
    const playBtnEl = document.createElement('button');
    playBtnEl.type = 'button';
    playBtnEl.title = 'play';
    playBtnEl.classList.add(btnClass);
    playBtnEl.classList.add("u-tos");
    $container.append(playBtnEl);
}
function createIframe($container, src, title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.width = "100%";
    iframeEl.height = "100%";
    iframeEl.title = title;
    iframeEl.allow = 'autoplay';
    iframeEl.src = src;
    iframeEl.allowFullscreen = true;
    $container.append(iframeEl);
    $container.find('iframe').focus();
    return iframeEl;
}
function handleYoutubeEmbed($container) {
    let preconnected = false;
    const warmConnections = () => {
        if (preconnected)
            return;
        addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
        addPrefetch('preconnect', 'https://www.google.com');
        addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
        addPrefetch('preconnect', 'https://static.doubleclick.net');
        preconnected = true;
    };
    const addIframe = (videoId) => {
        const params = new URLSearchParams($container.attr('params') || []);
        params.append('autoplay', '1');
        const iframeEl = createIframe($container, `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`, getPlayLabel($container));
        iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        $container.addClass('lyt-activated');
    };
    const youTubeIdFromLink = (url) => url.match(/(?:https?:\/\/)?(?:www\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&]+)/)[1];
    addPlayButton($container, "lty-playbtn");
    $container.on('hover', () => {
        $container.off('hover');
        warmConnections();
    });
    $container.on('click', () => {
        $container.off('click');
        addIframe(youTubeIdFromLink($container.attr('src')));
    });
}
function handleSoundCloudEmbed($container) {
    let preconnected = false;
    const warmConnections = () => {
        if (preconnected)
            return;
        addPrefetch('preconnect', 'https://widget.sndcdn.com');
        addPrefetch('preconnect', 'https://w.soundcloud.com');
        preconnected = true;
    };
    const addIframe = (label, src) => {
        if (src.indexOf("autoplay") < -1) {
            src += ";auto_play=true";
        }
        else {
            src = src.replace("auto_play=false", "auto_play=true");
        }
        createIframe($container, src, label);
        $container.addClass('scld-activated');
    };
    addPlayButton($container, "scld-playbtn");
    $container.on('hover', () => {
        $container.off('hover');
        warmConnections();
    });
    $container.on('click', () => {
        $container.off('click');
        addIframe(getPlayLabel($container), $container.attr("src"));
    });
}
function handleACastEmbed($container) {
    let preconnected = false;
    const warmConnections = () => {
        if (preconnected)
            return;
        addPrefetch('preconnect', 'https://embed.acast.com');
        preconnected = true;
    };
    const addIframe = () => {
        const src = $container.attr("src");
        const iframe = createIframe($container, src, getPlayLabel($container));
        iframe.scrolling = "no";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay";
        window.addEventListener('message', event => {
            if (typeof event.data === "string") {
                try {
                    const parsedEvent = JSON.parse(event.data);
                    if (parsedEvent.event === "ready") {
                        const srcSplit = src.split("/");
                        const componentsLength = srcSplit.length;
                        if (componentsLength > 2) {
                            const message = {
                                eventName: 'postmessage:do:play',
                                data: { show: srcSplit[componentsLength - 2], episode: srcSplit[componentsLength - 1] }
                            };
                            iframe.contentWindow.postMessage(JSON.stringify(message), '*');
                        }
                    }
                }
                catch (e) {
                }
            }
        }, false);
    };
    $container.on('hover', () => {
        $container.off('hover');
        warmConnections();
    });
    $container.on('click', () => {
        $container.off('click');
        addIframe();
    });
}
function handleDefaultIframe($container) {
    $container.on('click', () => {
        $container.off('click');
        const iframe = createIframe($container, $container.attr("src"), getPlayLabel($container));
        iframe.scrolling = "no";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay";
    });
}
export const InitLazyEmbed = () => {
    $(document).ready(() => {
        $("lazy-embed").each((idx, elem) => {
            const $container = $(elem);
            const src = $container.attr("src");
            if ($container.attr("placeholder")) {
                $container.css("backgroundImage", `url("${$container.attr("placeholder")}")`);
            }
            if (src.indexOf("youtube") > -1) {
                handleYoutubeEmbed($container);
            }
            else if (src.indexOf("soundcloud") > -1) {
                handleSoundCloudEmbed($container);
            }
            else if (src.indexOf("acast") > -1) {
                handleACastEmbed($container);
            }
            else {
                handleDefaultIframe($container);
            }
        });
    });
};
//# sourceMappingURL=LazyEmbed.js.map